import $ from 'jquery'

window.global ||= window
window.$ ||= $
window.jQuery ||= $
